import { Block } from "@block";
import { useNavigation } from "@react-navigation/core";
import { StackActions } from "@react-navigation/routers";
import HeaderNav from "app/shared/components/header-nav/header-nav";
import GlobalModal, { createGlobalModal } from "app/shared/components/modal/global-modal/global-modal";
import { NavTitleBar, SubtitleNavTitleBar } from "app/shared/components/nav-title-bar/nav-title-bar";
import ScreenNameType from "app/shared/constant/nav-screen.type";
import { ITEMTRANSACTIONAUTO } from "app/shared/services/services-model.type";
import { spacing } from "app/shared/styles/spacing";
import { formatDate } from "app/shared/util/common";
import { formatNumberThousand } from "app/shared/util/format-currency";
import { useDesktopMediaQuery } from "app/shared/util/media-query";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { ScrollView } from "react-native";
import { useDispatch, useSelector } from "react-redux";
import { fetchAutoTopUpTransactionRequest, setAutoTopUpStore } from "../reducer/actions";
import {
  getAutoTopUpPendingTransactionSelector,
  getAutoTopUpResTransactionSelector,
  getAutoTopUpStoreSelector,
} from "../reducer/selectors";
import FilterTransactionTable, { FormAutoTopUpFilterHistory } from "./filter-history-table/filter-history";
import TransactionTable, { DataAutoToUpHistoryTableProps } from "./filter-history-table/history-table";

enum ActionFilter {
  Search,
  DataTable,
  Reset,
}

const ListAutoTopUpHistory = () => {
  const { dispatch } = useNavigation();
  const { t } = useTranslation();
  const dispatchStore = useDispatch();
  const isDesktop = useDesktopMediaQuery();

  const autoToUpStore = useSelector(getAutoTopUpStoreSelector);
  const listTransHistory = useSelector(getAutoTopUpResTransactionSelector);
  const pending = useSelector(getAutoTopUpPendingTransactionSelector);

  const [globalModalRef] = React.useState<React.RefObject<any>>(createGlobalModal());
  const [isShowTable, setShowTable] = React.useState<boolean>(false);
  const [dataList, setDataList] = React.useState<DataAutoToUpHistoryTableProps[]>([]);

  const goHome = () => {
    dispatch(StackActions.replace(ScreenNameType.HOME));
  };

  const goManager = () => {
    dispatch(StackActions.replace(ScreenNameType.LIST_PAYMENTS));
  };

  const subtitlesArrays: Array<SubtitleNavTitleBar> = [
    {
      name: t("FUNC_TRANG_CHU"),
      onPressSubtitle: () => goHome(),
    },
    {
      name: t("FUNC_THANH_TOAN"),
      onPressSubtitle: () => goManager(),
    },
    {
      name: t("AUTO_TOPUP_LICH_SU_GIAO_DICH"),
      onPressSubtitle: () => {},
    },
  ];

  const handleOnChange = (type: ActionFilter) => (_values: FormAutoTopUpFilterHistory) => {
    switch (type) {
      case ActionFilter.Search:
        requestSearch(_values);
        break;
      case ActionFilter.Reset:
        if (isShowTable) setShowTable(false);
        if (listTransHistory)
          dispatchStore(setAutoTopUpStore({ ...autoToUpStore, responseTransaction: undefined, statusTransaction: "init" }));
        break;
      default:
        break;
    }
  };

  const requestSearch = (data: FormAutoTopUpFilterHistory) => {
    if (isShowTable) setShowTable(false);
    dispatchStore(fetchAutoTopUpTransactionRequest(data));
  };

  const getDataTable = React.useCallback((_data?: ITEMTRANSACTIONAUTO[]) => {
    if (_data && _data?.length > 0) {
      _data.map((obj: DataAutoToUpHistoryTableProps, index: number) => {
        obj.id = String(index + 1);
        obj.CURRENCY_AMOUNT = formatNumberThousand(obj.amount);
        obj.FORMAT_TRANS_DATE = formatDate(obj.trandate);
        return obj;
      });
      return _data;
    }
    return [];
  }, []);

  React.useEffect(() => {
    const data: DataAutoToUpHistoryTableProps[] = getDataTable(listTransHistory);
    setDataList(data);
  }, [getDataTable, listTransHistory]);

  React.useEffect(() => {
    if (pending === "ok" && !isShowTable) {
      setShowTable(true);
    }
  }, [pending, isShowTable]);

  return (
    <Block flex={1}>
      <ScrollView>
        <HeaderNav />
        <NavTitleBar title={t("AUTO_TOPUP_LICH_SU_GIAO_DICH")} subtitles={subtitlesArrays} />
        <Block pv={spacing.huge} ph={isDesktop ? spacing.galactic : spacing.huge}>
          <FilterTransactionTable onChangeSearch={handleOnChange(ActionFilter.Search)} onReset={handleOnChange(ActionFilter.Reset)} />
          <TransactionTable data={dataList} onChangeData={() => {}} isShow={isShowTable} />
        </Block>
        <GlobalModal ref={globalModalRef} />
      </ScrollView>
    </Block>
  );
};

export default ListAutoTopUpHistory;
